/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {Asset, Device} from '@ion/core/src/types/entities';
import Chip from '@ion/dls/src/components/chip/Chip';
import {dlsColor} from '@ion/dls/src/theme/theme';

//defines the prop definitions for Group chips editor ...
export interface GroupChipsProps {
  value: string | string[];
  onChipClick: (value: string | string[], isDeviceChip: boolean, chipName: string) => void;
  isDeviceChip?: boolean;
  chips?: Device[] | Asset[];
};

/**
 * The GroupChips provides a list of devices/assets clickable chips.
 * It will show ViewAssetEditor/ViewDeviceEditor dialog when user click on chip from
 */
export const GroupChips = ({
  value,
  onChipClick,
  chips,
  isDeviceChip = false
}: GroupChipsProps) => {
  const chipClick = useCallback((e) => {
    onChipClick(value, isDeviceChip, e.target.innerText);
  }, [value, isDeviceChip]);

  return (
    <>
      {chips?.map((chip: Device | Asset) => (
        <Chip label={chip?.name}
          size={'large'}
          maxWidth={false}
          borderRadius={'56px'}
          labelColor={dlsColor('grey2')}
          onClick={chipClick}
          hoverDefault
          showCustomDeleteIcon
          noTextTransform />
      ))}
    </>
  );
};

export default GroupChips;
